var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { TIPTAP_TABLE_HEADER_CELL_TYPE } from "./../../ricos-content";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const tableConverter = {
  toTiptap: {
    types: [Node_Type.TABLE],
    convert: (node, visit) => ({
      type: Node_Type.TABLE,
      attrs: __spreadValues({
        id: node.id
      }, node.tableData),
      content: node.nodes.map((rowNode, rowIndex) => {
        var _a, _b;
        return {
          type: Node_Type.TABLE_ROW,
          attrs: { id: rowNode.id, height: (_b = (_a = node.tableData.dimensions) == null ? void 0 : _a.rowsHeight) == null ? void 0 : _b[rowIndex] },
          content: rowNode.nodes.map((colNode, colIndex) => {
            const { colsWidthRatio, colsMinWidth } = node.tableData.dimensions || {};
            const widthInPixel = ratioWidthToPixel(colsWidthRatio, colsMinWidth);
            return {
              type: rowIndex === 0 && node.tableData.rowHeader || colIndex === 0 && node.tableData.columnHeader ? TIPTAP_TABLE_HEADER_CELL_TYPE : Node_Type.TABLE_CELL,
              attrs: __spreadProps(__spreadValues({}, colNode.tableCellData), {
                id: colNode.id,
                colwidth: (widthInPixel == null ? void 0 : widthInPixel[colIndex]) && [widthInPixel[colIndex]]
              }),
              content: visit(colNode)
            };
          })
        };
      })
    })
  },
  fromTiptap: {
    types: [Node_Type.TABLE],
    convert: (node, visit) => {
      var _b;
      const { attrs = {} } = node;
      const _a = attrs, { id, dimensions } = _a, data = __objRest(_a, ["id", "dimensions"]);
      return {
        type: Node_Type.TABLE,
        id,
        tableData: __spreadProps(__spreadValues({}, data), {
          dimensions: __spreadProps(__spreadValues({}, dimensions), {
            rowsHeight: (_b = node.content) == null ? void 0 : _b.map((node2) => {
              var _a2;
              return (_a2 = node2.attrs) == null ? void 0 : _a2.height;
            })
          })
        }),
        nodes: visit(node)
      };
    }
  }
};
const tableRowConverter = {
  toTiptap: {
    types: [Node_Type.TABLE_ROW],
    convert: (node, visit) => ({
      type: Node_Type.TABLE_ROW,
      attrs: {
        id: node.id
      },
      content: visit(node)
    })
  },
  fromTiptap: {
    types: [Node_Type.TABLE_ROW],
    convert: (node, visit) => {
      const { attrs = {} } = node;
      const { id } = attrs;
      return {
        type: Node_Type.TABLE_ROW,
        id,
        nodes: visit(node)
      };
    }
  }
};
const tableHeaderCellConverter = {
  toTiptap: {
    types: [Node_Type.TABLE_CELL],
    convert: (node, visit) => ({
      type: Node_Type.TABLE_CELL,
      attrs: __spreadValues({
        id: node.id
      }, node.tableCellData),
      content: visit(node)
    })
  },
  fromTiptap: {
    types: [TIPTAP_TABLE_HEADER_CELL_TYPE, Node_Type.TABLE_CELL],
    convert: (node, visit) => {
      const { attrs = {} } = node;
      const _a = attrs, { id, colwidth: _ } = _a, data = __objRest(_a, ["id", "colwidth"]);
      return {
        type: Node_Type.TABLE_CELL,
        id,
        tableCellData: __spreadValues({}, data),
        nodes: visit(node)
      };
    }
  }
};
const ratioWidthToPixel = (colsWidthRatio, colsMinWidth) => {
  if (colsWidthRatio && colsMinWidth) {
    const smallestColRatio = Math.min(...colsWidthRatio);
    const smallestMinWidth = Math.min(...colsMinWidth);
    const ratio = smallestMinWidth / smallestColRatio;
    return colsWidthRatio.map((width) => width * ratio);
  }
};
export {
  tableConverter,
  tableHeaderCellConverter,
  tableRowConverter
};
//# sourceMappingURL=table-converters.js.map
